import './App.css';
import Home from './home';
function App() {
  return (
    <div>
      <Home />
    </div>
  );
}                                                                           

export default App;                          
